import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import servicosColaborador from "../../servicos/servicos-colaborador";
import servicosSetor from "../../servicos/servicos-setor";
import servicosCargo from "../../servicos/servicos-cargo";
import { Form } from "semantic-ui-react";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { ToastContainer, toast } from 'react-toastify';
import AuthContext from "../../servicos/autorizacao/AuthContex";
import { useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";
import Edit from "../../img/svgs/Edit";
import Delete from "../../img/svgs/Delete";
import Salvar from "../../img/svgs/Salvar";
import Cancel from "../../img/svgs/Cancel";
import servicosConvenia from "../../servicos/servicos-convenia";
import { Button } from "@mui/material";

const ListColaboradores = () => {
  const { user } = useContext(AuthContext);
  const autorizado = user.role === 'root' || user.role === 'admin';

  const [setores, setSetores] = useState(null);
  const [cargos, setCargos] = useState(null);
  const [valor, setValor] = useState();
  const [colaboradores, setColaboradores] = useState([]);
  const [editado, setEditado] = useState(false);
  const [deletado, setDeletado] = useState(false);
  const [show, setShow] = useState(false);
  const containerRef = useRef(null);
  const [idColaborador, setIdColaborador] = useState();
  const [showExcluir, setShowExcluir] = useState(false);
  const [idExcluir, setIdExcluir] = useState();
  const [invalido, setInvalido] = useState(false);
  const [showConfirmacao, setShowConfirmacao] = useState(false);
  const [qtdMostrar, setQtdMostrar] = useState(10);
  const [listaFiltrada, setListaFiltrada] = useState([]);

  const nome = useRef();
  const cpf = useRef();
  const rg = useRef();
  const data_nascimento = useRef();
  const email = useRef();
  const telefone = useRef();
  const acesso = useRef();
  const data_admissao = useRef();
  const nacionalidade = useRef();
  const endereco = useRef();
  const bairro = useRef();
  const numero = useRef();
  const cep = useRef();
  const AI = useRef();
  const complemento = useRef();
  const id_setor = useRef();
  const id_cargo = useRef();
  const password = useRef();

  const handleQtd = (e) => {
    let qtd = Number(e.target.value);
    setQtdMostrar(qtd);
  };

  useEffect(() => {
    function getDados() {
      servicosSetor.listarTodos()
        .then(response => {
          if (response.status === 200) {
            setSetores(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, []);

  useEffect(() => {
    function getDados() {
      servicosCargo.listarTodos()
        .then(response => {
          if (response.status === 200) {
            setCargos(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, []);

  useEffect(() => {
    servicosColaborador.listarTodos().then(response => {
      setColaboradores(response.data);
      setListaFiltrada(response.data);
    });
  }, [editado, deletado]);

  const handleClose = () => setShow(false);

  const handleShow = (colaborador) => {
    setInvalido(false);
    setValor(colaborador);
    setIdColaborador(colaborador.id_colaborador);
    setShow(true);
  };

  const handleCloseConfirmacao = () => {
    setShowConfirmacao(false);
  };

  const handleShowConfirmacao = () => {
    const nome = document.querySelector("#nome");
    const cpf = document.querySelector("#cpf");
    const data_nascimento = document.querySelector("#data_nascimento");
    const email = document.querySelector("#email");
    const endereco = document.querySelector("#endereco");
    const bairro = document.querySelector("#bairro");
    const numero = document.querySelector("#numero");
    const data_admissao = document.querySelector("#data_admissao");
    const cep = document.querySelector("#cep");
    const status = document.querySelector("#status");
    const passwordValue = password.current?.value; // Obter o valor da senha

    const qtdNome = String(nome.value).length;
    const qtdCpf = String(cpf.value).length;
    const qtdDataNascimento = String(data_nascimento.value).length;
    const qtdEmail = String(email.value).length;
    const qtdEndereco = String(endereco.value).length;
    const qtdBairro = String(bairro.value).length;
    const qtdNumero = String(numero.value).length;
    const qtdDataAdmissao = String(data_admissao.value).length;
    const qtdCep = String(cep.value).length;
    const flagStatus = status.value === 'A' || status.value === 'I';
    const qtdPassword = String(passwordValue || '').length;

    // Valida a senha apenas se preenchida (mínimo 6 caracteres)
    if (qtdNome < 2 || qtdCpf !== 14 || qtdDataNascimento < 1 || qtdEmail < 4 || qtdEndereco < 4 || qtdBairro < 4 || qtdNumero < 1 || qtdDataAdmissao < 1 || qtdCep !== 9 || flagStatus === false || (qtdPassword > 0 && qtdPassword < 6)) {
      setInvalido(true);
      if (qtdPassword > 0 && qtdPassword < 6) {
        toast.error("A senha, se preenchida, deve ter pelo menos 6 caracteres.", {
          theme: "colored",
        });
      } else {
        toast.error("Um ou mais campos obrigatórios não foram preenchidos corretamente.", {
          theme: "colored",
        });
      }
    } else {
      setShow(false);
      setShowConfirmacao(true);
    }
  };

  const handlePesquisa = (e) => {
    const pesquisa = e.target.value;
    let listaAtualizada = [];
    if (pesquisa !== "") {
      listaAtualizada = colaboradores.filter((item) => {
        return String(item.nome).toLowerCase().indexOf(pesquisa.toLowerCase()) !== -1;
      });
      setListaFiltrada(listaAtualizada);
    }
  };

  function limparCPF(cpfFormatado) {
    const cpfApenasNumeros = cpfFormatado.replace(/\D/g, '');
    return cpfApenasNumeros;
  }

  function encontrarUsuariosInativos(colaboradores, usuarios) {
    const usuariosSemColaborador = usuarios
      .filter(usuario =>
        !colaboradores
          .some(colaborador =>
            limparCPF(usuario.cpf) === colaborador.documents.cpf
          )
      )
      .filter(colab => colab.AI === "A" && colab.matricula !== '0');

    const colaboradoresSemUsuario = colaboradores.filter(colaborador =>
      !usuarios.some(usuario =>
        limparCPF(usuario.cpf) === colaborador.documents.cpf
      )
    );

    return {
      usuariosSemColaborador,
      colaboradoresSemUsuario,
    };
  }

  function normalizarString(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  function encontrarCargo(NomeCargo) {
    console.log('NomeCargo', NomeCargo);
    const cargoColaborador = cargos.filter(cargo =>
      normalizarString(String(cargo.nome_cargo).trim()) === normalizarString(String(NomeCargo).trim())
    );
    return cargoColaborador[0]?.id_cargo;
  }

  function encontrarSetor(NomeSetor) {
    console.log('nome setor', NomeSetor);
    const setorColaborador = setores.filter(setor =>
      normalizarString(String(setor.nome_setor).trim()) === normalizarString(String(NomeSetor).trim())
    );
    return setorColaborador[0]?.id_setor;
  }

  function formatarCPF(cpf) {
    cpf = cpf.replace(/\D/g, '');
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  function formatarNumeroCelular(numero) {
    numero = numero.replace(/\D/g, '');
    return numero.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }

  function formatarCEP(cep) {
    cep = cep.replace(/\D/g, '');
    return cep.replace(/(\d{5})(\d{3})/, '$1-$2');
  }

  function gerarNumeroAleatorio() {
    var numeroAleatorio = Math.floor(Math.random() * 90000000) + 10000000;
    return numeroAleatorio;
  }

  const criarColaborador = (data) => {
    if (data.matricula === '') {
      data.matricula = String(gerarNumeroAleatorio());
    }
    if (!Number(data.numero)) {
      data.numero = 0;
    }
    console.log('data criar', data);
    servicosColaborador.create(data)
      .then(response => {
        if (response.status === 201) {
          toast.success("Colaborador adicionado com sucesso!");
          setEditado(!editado);
        } else {
          toast.error(response.data.message, {
            theme: "light"
          });
        }
      }).catch(error => {
        toast.error(`${error?.response?.data?.message}, ${data.matricula}, ${data.cpf}. Ou os dados do convênia estão divergente do levmilhas: ${!Number(data.id_cargo) ?  `Cargo: ${data.id_cargo}` : ""}, ${!Number(data.id_setor) ?  `Setor: ${data.id_setor}` : ""}`  || 'Não foi possível cadastrar o Colaborador!', {
          theme: "colored",
          autoClose: false,
        });
        console.log(error);
      });
  };

  const sync = async () => {
    const listaColabClt = await servicosConvenia.listarTodosClt().then(response => {
      return response.data.data;
    }).catch(error => {
      console.log(error);
      return false;
    });

    const listaColabCormeciais = await servicosConvenia.listarTodosComerciais().then(response => {
      return response.data.data;
    }).catch(error => {
      console.log(error);
      return false;
    });

    const listaColabPj = await servicosConvenia.listarTodosPj().then(response => {
      return response.data.data;
    }).catch(error => {
      console.log(error);
      return false;
    });

    if (listaColabClt.length > 0 && listaColabCormeciais.length > 0 && listaColabPj.length > 0 && colaboradores.length > 0 && cargos.length > 0 && setores.length > 0) {
      const listaColab = [...listaColabClt, ...listaColabCormeciais, ...listaColabPj];
      let colabFiltrados = encontrarUsuariosInativos(listaColab, colaboradores);
      if (colabFiltrados.usuariosSemColaborador.length > 0) {
        for (const iterator of colabFiltrados.usuariosSemColaborador) {
          let data = {
            AI: "I"
          };
          servicosColaborador.editar(iterator.id_colaborador, data).then(response => {
            setEditado(!editado);
          }).catch(error => console.log(error));
        }
      }

      if (colabFiltrados.colaboradoresSemUsuario.length > 0) {
        const colaboradoresCltSemUsuario = listaColabClt.filter(colaborador =>
          colabFiltrados.colaboradoresSemUsuario.some(usuario =>
            usuario.documents.cpf === colaborador.documents.cpf
          )
        );

        const colaboradoresComerciaisSemUsuario = listaColabCormeciais.filter(colaborador =>
          colabFiltrados.colaboradoresSemUsuario.some(usuario =>
            usuario.documents.cpf === colaborador.documents.cpf
          )
        );

        const colaboradoresPjSemUsuario = listaColabPj.filter(colaborador =>
          colabFiltrados.colaboradoresSemUsuario.some(usuario =>
            usuario.documents.cpf === colaborador.documents.cpf
          )
        );

        if (colaboradoresCltSemUsuario.length > 0) {
          for (const iterator of colaboradoresCltSemUsuario) {
            servicosConvenia.getUserClt(iterator.id).then(response => {
              const colabConvenia = response.data.data;
              const dadosColaborador = {
                "id_setor": encontrarSetor(colabConvenia.department.name) || colabConvenia.department.name,
                "id_cargo": encontrarCargo(colabConvenia.job.name) || colabConvenia.job.name,
                "matricula": iterator.registration || gerarNumeroAleatorio(),
                "nome": colabConvenia.name + ' ' + colabConvenia.last_name,
                "cpf": formatarCPF(colabConvenia.documents.cpf),
                "rg": colabConvenia.documents.rg,
                "data_nascimento": colabConvenia.birth_date,
                "data_admissao": colabConvenia.hiring_date,
                "email": colabConvenia.alternative_email,
                "telefone": formatarNumeroCelular(colabConvenia.cellphone),
                "nacionalidade": "Brasil",
                "endereco": colabConvenia.address.address,
                "complemento": colabConvenia.address.complement,
                "bairro": colabConvenia.address.district,
                "numero": colabConvenia.address.number,
                "cep": formatarCEP(colabConvenia.address.zip_code),
                "AI": "A",
                "acesso": "simples"
              };
              try {
                criarColaborador(dadosColaborador);
              } catch (error) {
                console.log(error);
              }
            }).catch(error => console.log(error));
          }
        }

        if (colaboradoresComerciaisSemUsuario.length > 0) {
          for (const iterator of colaboradoresComerciaisSemUsuario) {
            servicosConvenia.getUserComercial(iterator.id).then(response => {
              const colabConvenia = response.data.data;
              const dadosColaborador = {
                "id_setor": encontrarSetor(colabConvenia.department.name) || colabConvenia.department.name,
                "id_cargo": encontrarCargo(colabConvenia.job.name) || colabConvenia.job.name,
                "nome": colabConvenia.name + ' ' + colabConvenia.last_name,
                "cpf": formatarCPF(colabConvenia.documents.cpf),
                "rg": colabConvenia.documents.rg,
                "data_nascimento": colabConvenia.birth_date,
                "data_admissao": colabConvenia.hiring_date,
                "email": colabConvenia.alternative_email,
                "telefone": formatarNumeroCelular(colabConvenia.cellphone),
                "nacionalidade": "Brasil",
                "endereco": colabConvenia.address.address,
                "complemento": colabConvenia.address.complement,
                "bairro": colabConvenia.address.district,
                "numero": colabConvenia.address.number,
                "cep": formatarCEP(colabConvenia.address.zip_code),
                "AI": "A",
                "acesso": "master",
                "matricula": ""
              };
              try {
                criarColaborador(dadosColaborador);
              } catch (error) {
                console.log(error);
              }
            }).catch(error => console.log(error));
          }
        }

        if (colaboradoresPjSemUsuario.length > 0) {
          for (const iterator of colabFiltrados.colaboradoresSemUsuario) {
            servicosConvenia.getUserPj(iterator.id).then(response => {
              const colabConvenia = response.data.data;
              const dadosColaborador = {
                "id_setor": encontrarSetor(colabConvenia.department.name) || colabConvenia.department.name,
                "id_cargo": encontrarCargo(colabConvenia.job.name) || colabConvenia.job.name,
                "nome": colabConvenia.name + ' ' + colabConvenia.last_name,
                "cpf": formatarCPF(colabConvenia.documents.cpf),
                "rg": colabConvenia.documents.rg,
                "data_nascimento": colabConvenia.birth_date,
                "data_admissao": colabConvenia.hiring_date,
                "email": colabConvenia.alternative_email,
                "telefone": formatarNumeroCelular(colabConvenia.cellphone),
                "nacionalidade": "Brasil",
                "endereco": colabConvenia.address.address,
                "complemento": colabConvenia.address.complement,
                "bairro": colabConvenia.address.district,
                "numero": colabConvenia.address.number,
                "cep": formatarCEP(colabConvenia.address.zip_code),
                "AI": "A",
                "acesso": "simples",
                "matricula": ""
              };
              try {
                criarColaborador(dadosColaborador);
              } catch (error) {
                console.log(error);
              }
            }).catch(error => console.log(error));
          }
        }
      }
    }
    return true;
  };

  const handleSync = async () => {
    await toast.promise(
      sync(),
      {
        pending: 'Processando',
        success: 'Sincronização realizada',
        error: 'Não foi possível efetuar a sincronização'
      }
    );
  };

  const SelectSetores = () => {
    if (setores === null) {
      return <>Carregando lista de setores</>;
    }
    return (
      <>
        <Form.Field className="mx-5 mt-4">
          <label htmlFor="id_setor" className="form-label label-texto">Setor</label>
          <select className="input-cadastro" name="id_setor" ref={id_setor} aria-label="" defaultValue={valor?.Setor[0].id_setor}>
            <option value={0}>Selecione</option>
            {setores.map((item) => {
              const id = item.id_setor;
              return <option key={id} value={id}>{item.nome_setor}</option>;
            })}
          </select>
        </Form.Field>
      </>
    );
  };

  const SelectCargos = () => {
    if (cargos === null) {
      return <>Carregando lista de cargos</>;
    }
    return (
      <>
        <Form.Field className="mx-5 mt-4">
          <label htmlFor="id_cargo" className="form-label label-texto">Cargo</label>
          <select className="input-cadastro" name="id_cargo" ref={id_cargo} aria-label="" defaultValue={valor?.Cargo[0].id_cargo}>
            <option value={0}>Selecione</option>
            {cargos.map((item) => {
              const id = item.id_cargo;
              return <option key={id} value={id}>{item.nome_cargo}</option>;
            })}
          </select>
        </Form.Field>
      </>
    );
  };

  const deletarColaborador = () => {
    setDeletado(false);
    servicosColaborador.deletar(idExcluir).then(response => {
      if (response.status === 200) {
        setDeletado(true);
        toast.success("Colaborador deletado com sucesso!", {
          theme: "colored",
        });
      }
    }).catch(error => {
      console.log(error);
      toast.error("Não foi possível deletar o Colaborador!", {
        theme: "colored"
      });
    });
    setShowExcluir(false);
  };

  const editarColaborador = (nome, cpf, rg, data_nascimento, email, telefone, acesso, data_admissao, nacionalidade, endereco, bairro, numero, cep, AI, complemento, id_setor, id_cargo, password) => {
    setEditado(false);
    const data = {
      id_setor,
      id_cargo,
      nome,
      cpf,
      rg,
      data_nascimento,
      email,
      telefone,
      data_admissao,
      nacionalidade,
      endereco,
      complemento,
      bairro,
      numero,
      cep,
      acesso,
      AI
    };
    // Adiciona a senha apenas se não estiver vazia
    if (password && password.trim() !== '') {
      data.password = password;
    }
    servicosColaborador.editar(idColaborador, data).then(response => {
      if (response.status === 200) {
        toast.success("Colaborador alterado com sucesso!", {
          theme: "colored",
        });
        setShowConfirmacao(false);
        setEditado(true);
      }
    }).catch(error => {
      console.log(error);
      toast.error("Não foi possível alterar o Colaborador!", {
        theme: "colored"
      });
      setShowConfirmacao(false);
    });
    handleClose();
  };

  const handleCloseExcluir = () => {
    setShowExcluir(false);
  };

  const handleShowExcluir = (id) => {
    setShowExcluir(true);
    setIdExcluir(id);
  };

  const ModalEditar = () => {
    return (
      <Modal className="modal-lg modal-edit-colaborador" show={show} onHide={handleClose}>
        <Modal.Body className="">
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>
                  <SelectCargos />
                  <Form.Field className="mx-5 required">
                    <label htmlFor="nome" className="form-label label-texto">Nome</label>
                    <input className="input-cadastro" id="nome" defaultValue={valor?.nome} ref={nome}></input>
                  </Form.Field>
                  <Form.Field className="mx-5 ms-5 required">
                    <label htmlFor="cpf" className="form-label label-texto">CPF</label>
                    <input className="input-cadastro" placeholder="000.000.000-00" id="cpf" defaultValue={valor?.cpf} ref={cpf}></input>
                  </Form.Field>
                  <Form.Field className="mx-5">
                    <label htmlFor="rg" className="form-label label-texto">RG</label>
                    <input className="input-cadastro" defaultValue={valor?.rg} ref={rg}></input>
                  </Form.Field>
                  <Form.Field className="mx-5 required">
                    <label htmlFor="data_nascimento" className="form-label label-texto">Data De Nascimento</label>
                    <input className="input-cadastro" id="data_nascimento" type="date" defaultValue={valor?.data_nascimento} ref={data_nascimento}></input>
                  </Form.Field>
                  <Form.Field className="mx-5 required">
                    <label htmlFor="email" className="form-label label-texto">E-mail</label>
                    <input className="input-cadastro" id="email" defaultValue={valor?.email} ref={email}></input>
                  </Form.Field>
                  <Form.Field className="mx-5">
                    <label htmlFor="telefone" className="form-label label-texto">Telefone</label>
                    <input className="input-cadastro" placeholder="(00) 00000-0000" defaultValue={valor?.telefone} ref={telefone}></input>
                  </Form.Field>
                  {autorizado && (
                    <Form.Field className="mx-5">
                      <label htmlFor="acesso" className="form-label label-texto">Acesso</label>
                      <select className="form-select input-cadastro" name="acesso" ref={acesso} aria-label="" defaultValue={valor?.acesso}>
                        <option value="admin">Admin</option>
                        <option value="gestor">Gestor</option>
                        <option value="master">Master</option>
                        <option value="simples">Simples</option>
                        <option value="vip">Vip</option>
                        {user.role === 'root' && <option value="root">Root</option>}
                      </select>
                    </Form.Field>
                  )}
                  <Form.Field className="mx-5">
                    <label htmlFor="password" className="form-label label-texto">Senha</label>
                    <input className="input-cadastro" type="password" id="password" ref={password} defaultValue={valor?.password}></input>
                  </Form.Field>
                </div>
                <div>
                  <SelectSetores />
                  <Form.Field className="mx-5">
                    <label htmlFor="nacionalidade" className="form-label label-texto">Nacionalidade</label>
                    <input className="input-cadastro" defaultValue={valor?.nacionalidade} ref={nacionalidade}></input>
                  </Form.Field>
                  <Form.Field className="mx-5 required">
                    <label htmlFor="endereco" className="form-label label-texto">Endereço</label>
                    <input className="input-cadastro" id="endereco" defaultValue={valor?.endereco} ref={endereco}></input>
                  </Form.Field>
                  <Form.Field className="mx-5 required">
                    <label htmlFor="bairro" className="form-label label-texto">Bairro</label>
                    <input className="input-cadastro" id="bairro" defaultValue={valor?.bairro} ref={bairro}></input>
                  </Form.Field>
                  <Form.Field className="mx-5 required">
                    <label htmlFor="numero" className="form-label label-texto">Número</label>
                    <input className="input-cadastro" id="numero" defaultValue={valor?.numero} ref={numero}></input>
                  </Form.Field>
                  <Form.Field className="mx-5 required">
                    <label htmlFor="data_admissao" className="form-label label-texto">Data de Admissão</label>
                    <input className="input-cadastro" id="data_admissao" type="date" defaultValue={valor?.data_admissao} ref={data_admissao}></input>
                  </Form.Field>
                  <Form.Field className="mx-5">
                    <label htmlFor="complemento" className="form-label label-texto">Complemento</label>
                    <input className="input-cadastro" id="complemento" defaultValue={valor?.complemento} ref={complemento}></input>
                  </Form.Field>
                  <Form.Field className="mx-5 required">
                    <label htmlFor="cep" className="form-label label-texto">CEP</label>
                    <input className="input-cadastro" placeholder="00000-000" id="cep" defaultValue={valor?.cep} ref={cep}></input>
                  </Form.Field>
                  <Form.Field className="mx-5">
                    <label htmlFor="AI" className="form-label label-texto">Status</label>
                    <select className="form-select input-cadastro" id="status" ref={AI} aria-label="" defaultValue={valor?.AI}>
                      <option value="A">Ativo</option>
                      <option value="I">Inativo</option>
                    </select>
                  </Form.Field>
                  <Form.Field className="mx-5 mt-4">
                    <button className="border-1 btn-icones rounded p-1" onClick={handleShowConfirmacao}>
                      <Salvar /><span> Salvar</span>
                    </button>
                    <button className="btn-icones border-1 rounded p-1 ms-2" onClick={handleClose}>
                      <Cancel /> <span> Voltar</span>
                    </button>
                  </Form.Field>
                  {invalido && <p className="errosValidacao">Um ou mais campos obrigatórios não foram preenchidos corretamente.</p>}
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  const ModalConfirmacao = (props) => {
    return (
      <div>
        <Modal className="modal-confirmar-colaborador" show={showConfirmacao} onHide={handleCloseConfirmacao}>
          <Modal.Body className="ms-3 mt-4">
            <span className="mb-3">Você deseja realmente alterar o Colaborador?</span>
            {props.nome && <p className="mb-3"><strong>Nome:</strong> {props.nome}</p>}
            {props.cpf && <p><strong>CPF:</strong> {props.cpf}</p>}
            {props.rg && <p><strong>RG:</strong> {props.rg}</p>}
            {props.data_nascimento && <p><strong>Data de Nascimento:</strong> {props.data_nascimento}</p>}
            {props.email && <p><strong>E-mail:</strong> {props.email}</p>}
            {props.telefone && <p><strong>Telefone:</strong> {props.telefone}</p>}
            {props.acesso && <p><strong>Acesso:</strong> {props.acesso}</p>}
            {props.data_admissao && <p><strong>Data de Admissão:</strong> {props.data_admissao}</p>}
            {props.nacionalidade && <p><strong>Nacionalidade:</strong> {props.nacionalidade}</p>}
            {props.endereco && <p><strong>Endereço:</strong> {props.endereco}</p>}
            {props.bairro && <p><strong>Bairro:</strong> {props.bairro}</p>}
            {props.numero && <p><strong>Número:</strong> {props.numero}</p>}
            {props.cep && <p><strong>CEP:</strong> {props.cep}</p>}
            {props.AI && <p><strong>AI:</strong> {props.AI}</p>}
            {props.complemento && <p><strong>Complemento:</strong> {props.complemento}</p>}
            {props.id_setor && <p><strong>ID Setor:</strong> {props.id_setor}</p>}
            {props.id_cargo && <p><strong>ID Cargo:</strong> {props.id_cargo}</p>}
            {props.password && <p><strong>Senha:</strong> {props.password}</p>}
          </Modal.Body>
          <span className="text-center mb-4">
            <button type="button" className="rounded border-1 btn-icones p-1 w-25 me-3" onClick={() => editarColaborador(props.nome, props.cpf, props.rg, props.data_nascimento, props.email, props.telefone, props.acesso, props.data_admissao, props.nacionalidade, props.endereco, props.bairro, props.numero, props.cep, props.AI, props.complemento, props.id_setor, props.id_cargo, props.password)}><Salvar /><span className="pt-1"> Salvar</span></button>
            <button type="button" className="rounded border-1 p-1 btn-icones w-25" onClick={handleCloseConfirmacao}><Cancel /><span className="pt-1"> Cancelar</span></button>
          </span>
        </Modal>
      </div>
    );
  };

  const ModalExcluir = () => {
    return (
      <div>
        <Modal className="modal-confirmacao" show={showExcluir} onHide={handleCloseExcluir}>
          <Modal.Body className="">
            <span>Você deseja realmente deletar o Colaborador?</span> <br />
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="rounded w-25 border-1 p-1 btn-icones" onClick={deletarColaborador}><Salvar /><span> Confirmar</span></button>
            <button type="button" className="rounded w-25 border-1 p-1 btn-icones" onClick={handleCloseExcluir}><Cancel /><span> Voltar</span></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  };

  const columnsColaborador = [
    {
      field: "edit",
      headerName: "Editar",
      align: "center",
      sortable: false,
      width: 60,
      renderCell: (params) => {
        return <button className="border-0 text-light rounded p-1 btn-icones" onClick={() => handleShow(params.row)} ><Edit /></button>;
      }
    },
    { field: "id_colaborador", headerName: "ID", width: 45 },
    {
      field: "nome",
      headerName: "Nome",
      width: 250,
      editable: true,
    },
    {
      field: "cpf",
      headerName: "CPF",
      width: 120,
      editable: false,
    },
    {
      field: "matricula",
      headerName: "Matrícula",
      width: 120,
      editable: false,
    },
    {
      field: "rg",
      headerName: "RG",
      width: 100,
      editable: false,
    },
    {
      field: "email",
      headerName: "E-mail",
      width: 250,
      editable: false,
    },
    {
      field: "cargo",
      headerName: "Cargo",
      width: 200,
      editable: true,
      valueGetter: (params) => {
        return params.row.Cargo[0].nome_cargo;
      }
    },
    {
      field: "setor",
      headerName: "Setor",
      width: 200,
      editable: true,
      valueGetter: (params) => {
        return params.row.Setor[0].nome_setor;
      }
    },
    {
      field: "termo",
      headerName: "Ac. Termo",
      width: 100,
      editable: true,
      valueGetter: (params) => {
        return params.row.termo === true ? "Sim" : "Não";
      }
    },
    {
      field: "AI",
      headerName: "Status",
      width: 50,
      editable: false,
    },
    {
      field: "acesso",
      headerName: "Acesso",
      width: 80,
      editable: false,
    },
    {
      field: "delete",
      headerName: "Excluir",
      align: "center",
      sortable: false,
      width: 60,
      renderCell: (params) => {
        if (user.role === 'root' || user.role === 'admin') {
          return <button className="border-0 text-light rounded p-1 btn-icones" onClick={() => handleShowExcluir(params.row.id_colaborador)} ><Delete /></button>;
        } else {
          return <button className="text-dark border-1 text-light rounded p-1 btn-icones" disabled ><Delete /></button>;
        }
      }
    },
  ];

  return (
    <>
      <ToastContainer />
      <NavMenu />
      <ModalConfirmacao
        nome={nome?.current?.value}
        cpf={cpf?.current?.value}
        rg={rg?.current?.value}
        data_nascimento={data_nascimento?.current?.value}
        email={email?.current?.value}
        telefone={telefone?.current?.value}
        acesso={acesso?.current?.value}
        data_admissao={data_admissao?.current?.value}
        nacionalidade={nacionalidade?.current?.value}
        endereco={endereco?.current?.value}
        bairro={bairro?.current?.value}
        numero={numero?.current?.value}
        cep={cep?.current?.value}
        AI={AI?.current?.value}
        complemento={complemento?.current?.value}
        id_setor={id_setor?.current?.value}
        id_cargo={id_cargo?.current?.value}
        password={password?.current?.value}
      />
      <ModalExcluir />
      <div className="d-flex col container">
        <div className="w-25">
          <MenuLateral />
        </div>
        <div className="w-75 tabelas-gerenciais">
          <ModalEditar />
          <div className="d-flex align-items-center justify-content-start">
            <div className="d-flex justify-content-center align-items-center">
              <div>Listar</div>
              <div>
                <select className="form-select rounded-5 ms-3" style={{ width: 70 }} name="acesso" onChange={handleQtd} aria-label="">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>
            <div className="">
              <input
                className="border-1 rounded-5 p-2 ms-1"
                type="text"
                id="pesquisa"
                placeholder="Pesquise pelo nome"
                onChange={handlePesquisa}
              />
            </div>
            <div>
              <Button variant="contained" color="warning" onClick={() => handleSync()} style={{ borderRadius: "25px", height: "34px", marginLeft: "10px" }}>
                Sincronizar
              </Button>
            </div>
          </div>
          <Box sx={{ height: 650, width: 950, marginTop: 1 }}>
            <DataGrid
              localeText={localizedTextsMap}
              rows={listaFiltrada}
              columns={columnsColaborador}
              pageSize={qtdMostrar}
              rowsPerPageOptions={[qtdMostrar]}
              disableSelectionOnClick
              getRowId={(row) => row.id_colaborador}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
              }
            />
          </Box>
        </div>
      </div>
    </>
  );
};

export default ListColaboradores;